"use client";

/**
 * API Hooks - Main Re-export File
 * 
 * This file re-exports all API hooks from the organized api/ folder structure.
 * The actual implementations are now split into smaller, focused modules:
 * 
 * - api/types.ts: All shared types and interfaces
 * - api/config.ts: API configuration and constants
 * - api/query-keys.ts: Query key factory pattern
 * - api/utils.ts: Shared utility functions
 * - api/calendar/: Calendar-related hooks and utilities
 * - api/booking/: Booking system hooks
 * - api/account/: Account management and OAuth hooks
 * - api/crm/: CRM integration hooks
 * 
 * BACKWARD COMPATIBILITY:
 * All existing imports continue to work exactly as before.
 * No changes needed to consuming code.
 * 
 * Example usage (unchanged):
 * import { useGoogleCalendarData, useBookingMutation } from "@/hooks/use-api";
 */

export * from "./api/index.js";
